import { CreateOrderReqDto } from '@app/entities/orders/interfaces/create-order.req.dto';

export class AddToCart {
  static readonly type = '[Cart] Add to cart';
  constructor(public imageDetailsId: number) {}
}

export class RemoveFromCart {
  static readonly type = '[Cart] Remove from cart';
  constructor(public imageDetailsId: number) {}
}

export class ClearCart {
  static readonly type = '[Cart] Clear the cart';
}

export class CreateOrder {
  static readonly type = '[Cart] Create order';
  constructor(public data: CreateOrderReqDto) {}
}

export class LoadOrderDetails {
  static readonly type = '[Cart] Load order details';
}

export class UpadteOrderAmout {
  static readonly type =
    '[Cart] Update order total amount (depends on the tax rate)';
  constructor(public taxRate: number) {}
}
